import { checkInternal as check } from './lib/checkInternal'
import { removeInternal as remove } from './lib/removeInternal'
import { setInternal as set } from './lib/setInternal'
import { checkInternalInUrlParams as checkInUrlParams } from './model/checkInternalInUrlParams'

export default {
	set,
	check,
	remove,

	checkInUrlParams
}
